import { AfterViewInit, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { ConfigService } from '../../../services/config.service';
import { CustomerType } from '../../../models/client-configuration';
import { MtnRequest } from 'src/app/services/api/mtn/mtn.request';
import { MtnApiService } from 'src/app/services/api/mtn/mtn.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import moment from 'moment';
import { InfoDialogFacade } from 'src/app/_core/state/dialogs/info/info.facade';

@Component({
  selector: 'app-mtn-landing',
  templateUrl: './mtn-landing.component.html',
  styleUrls: ['./mtn-landing.component.scss'],
})
export class MtnLandingComponent implements OnInit, AfterViewInit, OnDestroy {

  readonly showConfirmationDialog = signal(false);

  customerType: CustomerType;

  constructor(
    private authService: AuthService,
    private configService: ConfigService,
    private router: Router,
    private mtnApiService: MtnApiService,
    private dialog: MatDialog
  ) {}

  ngOnDestroy(): void {
    document.querySelector<HTMLElement>('app-root').style.background = 'transparent';
  }

  ngAfterViewInit(): void {
    document.querySelector<HTMLElement>('app-root').style.background = 'black';
  }

  ngOnInit() {
    const whitelistClientList = [
      'P0001', // test-developer
      'E1133', // mtn
    ];

    if (this.authService.isAuthenticated() || !whitelistClientList.includes(this.configService.get().codCliente)) {
      this.router.navigate(['/']);
      this.customerType = this.configService.customerType;
    }
  }

  onSave() {
    const form = document.querySelector('form');
    const dataForm = new FormData(form);
    const expirateDate = moment().add(10, 'days').valueOf();
    const mtnRequest: MtnRequest = {
      name: String(dataForm.get('firstname')) + ' '.concat(String(dataForm.get('lastname'))),
      email: String(dataForm.get('email')),
      externalId: String(dataForm.get('email')),
      country: String(dataForm.get('country')),
      gender: String(dataForm.get('gender')) === 'Male' ? '1' : '2',
      additionalInfo: {
        password: String(dataForm.get('password')),
        expiringDate: expirateDate,
        signUpDate: moment().valueOf(),
        identifierType: 'EMAIL',
      },
      customer: 'BI136',
      policy: '40427',
    };
    form.reportValidity();
    if (form.reportValidity()) {
      this.mtnApiService.createUserAccountMTN(mtnRequest).subscribe((response) => {
        if (response) {
          this.showConfirmationDialog.set(true);
        }
      });
    }
  }

  scrollToContactForm() {
    const section = document.getElementById('contactForm');
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
